"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CLOSE_BTN_ALIGN = exports.CANCEL = void 0;
var MODAL_DEFAULTS = {
  BACKGROUND: 'default',
  OVERLAY_BG_COLOR: 'black',
  OVERLAY_OPACITY: '0.8',
  ZINDEX: 10,
  OVERFLOW: 'auto',
  HEADERPADDINGBOTTOM: 'small',
  MODALCONTENTPADDINGTOP: 'small'
};
var _default = MODAL_DEFAULTS;
exports.default = _default;
var CLOSE_BTN_ALIGN = ['left', 'right'];
exports.CLOSE_BTN_ALIGN = CLOSE_BTN_ALIGN;
var CANCEL = 'cancel';
exports.CANCEL = CANCEL;